import React, { useEffect, useState } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { PlusCircle } from "react-feather";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";

export default function Tabs({ tabs, activeTab, onTabChange, classNameUL }) {
  const [active, setActive] = useState("");

  const handleOnTabChange = (tab) => {
    if (onTabChange) {
      onTabChange(tab);
    }
  };

  const toggle = (tab) => {
    if (active !== tab) {
      setActive(tab);
      handleOnTabChange(tab);
    }
  };

  useEffect(() => {
    if (!activeTab) {
      return;
    }

    setActive(activeTab);
  }, [activeTab]);

  return (
    <>
      <Nav tabs className={classNameUL}>
        {tabs.map((tab) =>
          tab.id === "add" ? (
            <a href={tab.href} style={{ marginTop: 5 }}>
              <PlusCircle />
            </a>
          ) : (
            <NavItem key={tab.title} hidden={tab.hidden}>
              <NavLink
                href={`#${tab.id}`}
                className={classnames({
                  active: active === tab.id,
                })}
                onClick={() => {
                  toggle(tab.id);
                }}
              >
                <div className="title">{tab.title}</div>
              </NavLink>
            </NavItem>
          )
        )}
      </Nav>

      <TabContent activeTab={active}>
        {tabs.map((tab) => (
          <TabPane key={tab.id} tabId={tab.id} hidden={tab.hidden}>
            {tab.content}
          </TabPane>
        ))}
      </TabContent>
    </>
  );
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.any.isRequired,
      title: PropTypes.string.isRequired,
      content: PropTypes.any.isRequired,
    })
  ).isRequired,
};
